import {DialogHeader} from '@/components/ui/dialog-atoms/DialogAtoms'
import {Text} from '@/components/ui/text/Text'
import styled, {css} from 'styled-components'

export const StyledDialogHeader = styled(DialogHeader)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 2}px;
        align-items: flex-start;
    `
)

export const StyledDeleteDialogHintText = styled(Text)(
    ({theme: {palette}}) => css`
        color: ${palette.neutral['500']};
        & b {
            font-weight: 700;
            color: ${palette.neutral['950']};
        }
    `
)

export const StyledTargetDeletionNameText = styled(Text)(
    ({theme: {spacing, palette}}) => css`
        padding-left: ${spacing}px;
        font-weight: 500;
        color: ${palette.neutral['950']};
        &:before {
            content: '• ';
        }
    `
)
